import { render } from "./health.vue?vue&type=template&id=7d22ae64&scoped=true"
import script from "./health.vue?vue&type=script&lang=js"
export * from "./health.vue?vue&type=script&lang=js"

import "./health.vue?vue&type=style&index=0&id=7d22ae64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d22ae64"]])

export default __exports__